import React, { useState } from 'react'
import { Drawer, Box } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import NotificationTab from './NotificationTabs';

const NotificationPanel = (props) => {

  const { openNotitficationPanel, setOpenNotificationPanel, getValue, defaultTab = 0 } = props;

  const [number, setNumber] = useState('')

  const list = () => (
    <Box
      className="notification-panel"
      sx={{ width: 400 }}
      role="presentation"
      onKeyDown={() => setOpenNotificationPanel(false)}
    >
      <div className="notification-panel-head">
        <h4>Notifications</h4>
        <button
          type="button"
          className="head-close"
          aria-label="Close notifications"
          onClick={() => setOpenNotificationPanel(false)}
        >
          <ClearIcon />
        </button>
      </div>
      <NotificationTab number={number} setNumber={setNumber} getValue={getValue} setOpenNotificationPanel={setOpenNotificationPanel}  defaultTab={defaultTab} />
    </Box>
  );

  return (
    <div>
      {/* classed so the rounded edge is scoped to this drawer — styling
          .MuiDrawer-paper bare would round every drawer in the app */}
      <Drawer
        className="notification-drawer"
        sx={{ width: 450 }}
        anchor="right"
        open={openNotitficationPanel}
        onClose={() => setOpenNotificationPanel(false)}
      >
        {list()}
      </Drawer>
    </div>
  )
}

export default NotificationPanel;
